import { render, staticRenderFns } from "./CreditNoteListBuyer.vue?vue&type=template&id=28646a94&scoped=true"
import script from "./CreditNoteListBuyer.vue?vue&type=script&lang=js"
export * from "./CreditNoteListBuyer.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteListBuyer.vue?vue&type=style&index=0&id=28646a94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28646a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28646a94')) {
      api.createRecord('28646a94', component.options)
    } else {
      api.reload('28646a94', component.options)
    }
    module.hot.accept("./CreditNoteListBuyer.vue?vue&type=template&id=28646a94&scoped=true", function () {
      api.rerender('28646a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/creditnote/CreditNoteListBuyer.vue"
export default component.exports